<template>
  <section>
    <!-- Breadcrumbs -->
    <ol class="breadcrumb container d-none d-sm-flex">
      <li>
        <a href="/" class="text-dark has-icon icon-l">
          <i class="material-icons"></i>
          <span>Home</span>
        </a>
      </li>
      <li class="active">
        <span>Latest Offers </span>
      </li>
    </ol>

    <!-- Header Image -->
    <section class="app-hero-img offer-header d-none d-sm-block">
      <picture class="has-object-fit">
        <source
          media="(min-width: 1366px)"
          class="img-fluid"
          data-src="https://images.trailfinders.com/asset/2895b2/TF2659761/Depositphotos_8613539_xl-2015_1500x1500.jpg"
        />
        <source
          media="(min-width: 768px)"
          class="img-fluid"
          data-src="https://images.trailfinders.com/asset/2895b2/TF2659761/Depositphotos_8613539_xl-2015_1500x1500.jpg"
        />
        <source
          media="(max-width: 767px)"
          class="img-fluid"
          data-src="https://images.trailfinders.com/asset/2895b2/TF2659761/Depositphotos_8613539_xl-2015_750x750.jpg"
        />
        <img
          onerror="javascript:imgerror.call(this, event);"
          data-object-fit="cover"
          class="img-fluid lazy"
          data-src="https://images.trailfinders.com/asset/2895b2/TF2659761/Depositphotos_8613539_xl-2015_1500x1500.jpg"
          alt="special_offer_banner"
          title="special_offer_banner"
        />
      </picture>

      <div class="hero-img-caption">
        <div class="caption-cell">
          <div class="container-fluid caption-inner">
            <h1 class="caption-inner-hero-title">
              <span class="hero-title-location">Latest Offers</span>
            </h1>
          </div>
        </div>
      </div>
    </section>

    <main id="vue-app-homepage" class="app-mast-main">
      <!-- Today's Best Offers -->
      <section class="app-section app-section-light container-fluid">
        <!-- <h1 class="pb-5 text-center">Latest Offers</h1> -->
        <h3 class="section-heading pt-5 pt-lg-0">
          Explore our offers by Holiday Style
        </h3>
        <div class="app-best-offers container p-0">
          <section class="row">
            <!-- Browse By Experience -->
            <div class="col-12">
              <div class="row justify-content-center">
                <!-- panel -->
                <a
                  v-for="(type, index) in holidayStyles"
                  :key="index + '-' + type.value"
                  class="col-12 col-sm-6 col-md-4 col-lg-3 m-2 special-offer-tile"
                  :href="getIndividualURL(type)"
                >
                  <div class="card border-0 h-100 shadow mb-3">
                    <figure class="figure has-object-fit has-caption m-2">
                      <!-- img caption -->
                      <div class="img-caption">
                        <div class="caption-cell">
                          <div class="cell-inner">
                            <h5>{{ type.value }}</h5>
                          </div>
                        </div>
                      </div>

                      <img
                     
                        :data-src="type.img"
                        :src="type.img"
                        class="img-fluid img-grow lazy"
                        :alt="type.value"
                        :title="type.value"
                      />
                    </figure>
                  </div>
                </a>
                <!-- panel -->
               
              </div>
            </div>
          </section>
        </div>
      </section>

      <!-- Top Offers -->
      <section
        id="refine-deals"
        class="app-section app-section-grey container-fluid"
      >
        <h3 class="section-heading">A snapshot of today's offers</h3>
        <div class="app-red-hot-offers container p-0">
          <!-- Filters -->
          <section class="row has-full-width-select mb-3">
            <!-- Filter by country -->
            <div class="col-12 col-md-3 filter-btn">
              <div class="form-control" @click="dropdownToggleDestination">
                <span>Refine By Destination</span>
                <div class="box-icon"></div>
              </div>
            </div>

            <!-- Filter by Type -->
            <div class="col-12 col-md-3 filter-btn">
              <div class="form-control" @click="dropdownToggleStyle">
                <span>Refine By Holiday Style</span>
                <div class="box-icon"></div>
              </div>
            </div>

            <!-- Filter by sort -->
            <div class="col-12 col-md-3">
              <div class="form-group">
                <b-select
                  @change="sortFilterChanged"
                  v-model="filter.sort"
                  :options="sortOptions"
                  class="form-control"
                >
                </b-select>
              </div>
            </div>

            <!-- Filter by Offers per Page -->
            <div class="col-12 col-md-3">
              <div class="form-group">
                <b-select
                  @change="perPageFilterChanged"
                  v-model="filter.perPage"
                  :options="offersPerPage"
                  class="form-control"
                >
                </b-select>
              </div>
            </div>
          </section>

          <!-- Refine by destination dropdown -->
          <section class="dropdown" v-if="dropdownDestination">
            <div class="header-dropdown">
              <h2>By Destination</h2>
              <span @click="dropdownToggleDestination">X</span>
            </div>
            <div>
              <div class="form-group dropdown-boxes">
                <div
                  class="checkbox checkbox-custom"
                  v-for="(continent, index) in continents"
                  :key="index"
                >
                  <input
                    @change="filterChanged"
                    v-model="filter.destinations[continent.url]"
                    name="dest-filter"
                    :id="'checkbox-filter-by-continent-' + continent.url"
                    type="checkbox"
                  />
                  <label
                    :for="'checkbox-filter-by-continent-' + continent.url"
                    >{{ continent.name }}</label
                  >
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <button
                type="button"
                value="Reset"
                class="clear-btn"
                @click="clearDestinationFilter"
              >
                <span>Clear filters</span>
              </button>
            </div>
          </section>

          <!-- Refine by style dropdown -->
          <section class="dropdown" v-if="dropdownStyle">
            <div class="header-dropdown">
              <h2>By Holiday Style</h2>
              <span @click="dropdownToggleStyle">X</span>
            </div>
            <div>
              <div class="form-group dropdown-boxes">
                <div
                  class="checkbox checkbox-custom"
                  v-for="(style, index) in offerTypes"
                  :key="index"
                >
                  <input
                    @change="filterChanged"
                    v-model="filter.styles[style.image_tag]"
                    :id="'checkbox-filter-by-style-' + style.image_tag"
                    type="checkbox"
                  />
                  <label :for="'checkbox-filter-by-style-' + style.image_tag">{{
                    style.value
                  }}</label>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <button
                type="button"
                value="Reset"
                class="clear-btn"
                @click="clearStyleFilter"
              >
                <span>Clear filters</span>
              </button>
            </div>
          </section>

          <!-- Active Filters -->
          <div v-if="activeFilters.length > 0" class="row g-0">
            <div class="col-12">
              <div class="card border-0 rounded-0 m-0">
                <div class="card-body active-filters">
                  <p class="text-strong"><span>Your Active Filters:</span></p>
                  <ul class="active-filters">
                    <li
                      v-for="(checked, index) in activeFilters"
                      :key="index"
                      class="active-filter-item"
                    >
                      <a
                        class="
                          btn btn-grey btn-xs
                          has-icon
                          icon-r
                          active-filter-content
                        "
                        ><span>{{ checked }}</span
                        ><i
                          class="class material-icons icon-xs"
                          @click="removeFilter(checked)"
                          >close</i
                        ></a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- No results found alert -->
          <div v-if="filteredOffers.length === 0" class="row g-0">
            <div class="col-12">
              <div class="alert alert-danger rounded-0 text-center">
                <strong>Sorry no results found.</strong>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div v-if="filteredOffers.length > 0" class="row">
            <div class="col-12">
              <div class="col-12 text-center">
                <p class="text-strong mt-5">
                  Showing {{ startPageNumber }} - {{ endPageNumber }} of
                  {{ filteredOffers.length }} results
                </p>
                <div class="d-grid mb-4">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="total_rows"
                    :per-page="perPage"
                    v-show="total_rows > 0"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                  >
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>

          <!-- Offer Tiles -->
          <div class="row">
            <div
              v-for="(offer, index) in paginatedOffers"
              :key="index"
              @click="goToOffer(offer)"
              class="col-12 col-sm-6 col-md-4 pb-3"
            >
              <div class="card border-0 rounded-0 h-100 shadow">
                <figure class="has-object-fit overflow-hidden m-0 h-15rem">
                  <img
                    onerror="javascript:imgerror.call(this, event);"
                    :src="offer.image"
                    class="img-fluid img-grow lazy h-100"
                    :alt="offer.PACK_NAME"
                  />
                </figure>

                <div class="card-heading pt-2 px-2">
                  <!--If the package is not a hotel then show this heading-->
                  <h5 v-if="!offer.hotel_rating" class="card-title text-strong">
                    {{ offer.PACK_NAME }}
                  </h5>
                  <!--Show this heading if the package is a hotel to display star rating-->
                  <h5 v-if="offer.hotel_rating" class="card-title text-strong">
                    <div class="row g-1">
                      <div class="col-10 col-md-9">
                        <span>{{ offer.PACK_NAME }}</span>
                      </div>
                      <div class="col-2 col-md-3">
                        <span class="has-icon float-end"
                          ><img
                            onerror="javascript:imgerror.call(this, event);"
                            :src="
                              `https://cdn.trailfinders.com/${offer.hotel_rating}`
                            "
                            :alt="offer.hotel_rating"
                            :title="offer.hotel_rating"
                        /></span>
                      </div>
                    </div>
                  </h5>
                  <small class="d-inline-block"
                    ><span>Location:</span>
                    <span class="text-strong">{{ offer.country }}</span>
                  </small>
                </div>

                <div class="card-body pt-3 pb-0">
                  <div
                    v-if="offer.highlights || offer.including || offer.copy1"
                    class="scrollbar-holder h-12rem position-relative"
                  >
                    <div class="scrollbar-y">
                      <p
                        v-if="offer.savings_message"
                        v-html="offer.savings_message"
                      ></p>
                      <h6 class="text-strong mt-0">Including:</h6>
                      <ul
                        v-if="offer.input_offertype.indexOf('Cruise') >= 0"
                        class="offers-short-list mb-0"
                      >
                        <li
                          v-for="(highlight, index) in offer.highlights"
                          :key="index + highlight"
                          v-html="highlight"
                        ></li>
                      </ul>
                      <ul
                        v-if="offer.input_offertype.indexOf('Cruise') < 0"
                        class="offers-short-list mb-0"
                      >
                        <li
                          v-for="(include, index) in offer.including"
                          :key="index + include"
                          v-html="include"
                        ></li>
                      </ul>
                      <p
                        v-if="!offer.highlights || !offer.including"
                        v-html="offer.copy1"
                        class="mb-0"
                      ></p>
                    </div>
                  </div>
                  <!--This will only show for Flight Offers-->
                  <div
                    v-if="offer.input_webcopy"
                    class="scrollbar-holder h-12rem position-relative"
                  >
                    <div class="scrollbar-y">
                      <p v-html="offer.input_webcopy"></p>
                    </div>
                  </div>
                </div>

                <div class="card-footer p-3 pt-2 bg-white border-0">
                  <h5 class="mt-0 ms-1 text-success text-strong">
                    <span v-if="offer.price"
                      >{{ offer.duration }} {{ offer.currency
                      }}{{ offer.price }}pp</span
                    >
                  </h5>
                  <span
                    v-for="(type, index) in offer.input_offertype"
                    :key="index + type"
                    class="text-strong text-muted icon-l"
                  >
                    <i class="material-icons align-middle">bookmark</i>
                    <span>{{ type }}</span>
                  </span>
                </div>
              </div>
            </div>

           

            <!-- Pagination -->
            <div v-if="filteredOffers.length > 0" class="col-12">
              <div class="row">
                <div class="col-12 text-center">
                  <p class="text-strong mt-5">
                    Showing {{ startPageNumber }} - {{ endPageNumber }} of
                    {{ filteredOffers.length }} results
                  </p>
                  <div class="d-grid">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="total_rows"
                      :per-page="perPage"
                      v-show="total_rows > 0"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                    >
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
   
    </main>
  </section>
</template>

<script>
import {
  fetchOffers,
  fetchHolidayInspiration,
  updateMostPopular,
  getOfferTypes,
} from "../../services/api";

export default {
  data() {
    return {
      meta: {
        loaded: true,
      },
      perPage: 30,
      currentPage: 1,
      total_rows: 0,
      isOfficeHours: false,
      offers: [],
      items: [],
      filteredOffers: [],
      offerTypes: [],
      holidayStyles: [],
      continents: [],
      activeFilters: [],
      offerLinkData: [],
      dropdownDestination: false,
      dropdownStyle: false,
      brochure_link: "",
      brochure_image: "",
      brochure_new: "",
      filter: {
        destinations: {},
        styles: {},
        sort: "mostPopular",
        perPage: 30,
      },
      sortOptions: [
        { text: "Sort By", value: "" },
        { text: "Most Popular", value: "mostPopular" },
        { text: "Low to High", value: "ascending" },
        { text: "High to Low", value: "descending" },
      ],
      offersPerPage: [
        { text: "Offers Per Page", value: 30 },
        { text: "15", value: 15 },
        { text: "30", value: 30 },
        { text: "45", value: 45 },
        { text: "60", value: 60 },
        { text: "75", value: 75 },
        { text: "90", value: 90 },
        { text: "All", value: "All" },
      ],
    };
  },
  async mounted() {
    this.meta.loaded = true;
    this.siteVars = window.siteVar;
    if (!window.brochure_link) this.brochure_link = "/brochures";
    else this.brochure_link = window.brochure_link;
    if (!window.brochure_image)
      this.brochure_image =
        "https://www.trailfinders.com/graphics/brochures/media_bkg.png";
    else this.brochure_image = window.brochure_image;
    this.brochure_new = window.brochure_new;
    if (this.siteVars.isOfficeHours === "Yes") this.isOfficeHours = true;
    this.getOffers();
    this.sortFilterChanged();
  },
  methods: {
    async getOffers() { 
      fetchOffers().then((response) => {
        if (response.data && response.data.data && response.data.data.length > 0) {
          let tmp = response.data.data
          response.data.data = this.removeDuplicatesByField(tmp, 'PACK_NAME')
          this.offerTypes = response.data.keys.offer_types;
          this.continents = response.data.keys.continents;
          this.total_rows = this.offers.length;
          // Set initial order
          this.initialSortOrder(response.data.data);
          // Set amount of tours on offer types
          this.getHolidayTypeCount();
          // Now the amount of items relating to each holidaystyle has been set we can extract the styles
          this.extractHolidayStyles();
        }
      });
    },
    removeDuplicatesByField(arr, field) { //remove duplicate tours by name, leaving the most recently added
                return Object.values(
                    arr.reduce((acc, obj) => {
                        const key = obj[field];
                        if (!acc[key] || new Date(obj.created) > new Date(acc[key].created)) {
                            acc[key] = obj;
                        }
                        return acc;
                    }, {})
                );
            },
    async extractHolidayStyles() {
      fetchHolidayInspiration(this.siteVars.referer).then((response) => {
        this.holidayStyles = [];
        if (response) {
          // For storing pre-sorted holiday styles
          let tempStyles = [];
          for (const key of this.offerTypes) {
            const index = response.findIndex(
              (value) => value.HolidayType === key.value
            );
            const tmpObj = {};
            tmpObj.value = key.value;
            tmpObj.href =
              "/special-offers/style/" +
              key.value
                .toLowerCase()
                .split(" ")
                .join("-")
                .replace(/&/g, "and");

            if (index >= 0) {
              // tmpObj.sortOrder = response[index].sort_tile_order
              // tmpObj.href = response[index].InspirationLink;
              tmpObj.sortOrder = response[index].sortOrder;
              tmpObj.img = response[index].InspirationImage;
            } else {
              tmpObj.sortOrder = 500;
              tmpObj.img = `/graphics/latestoffers/thumbnails/${key.image_tag}.jpg`;
            }
            tempStyles.push(tmpObj);
          }
          // Sort styles
          const roundTheWorld = {value:'Round The World', href:'/flights/around-the-world', sortOrder:1000, img:'https://images.trailfinders.com/asset/294a13/TF2705938/artem-beliaikin-v6kii3H5CcU-unsplash_600x600.jpg'}
          tempStyles.push(roundTheWorld)
          this.holidayStyles = [...this.sortTileOrder(tempStyles)];
        }
      });
    },
    async goToOffer(_offer) {
      // Navigate to the next view depending on the type of offer
      if (_offer.input_offertype.includes("Cruise")) {
        window.location =
          window.location.origin +
          "/special-offers/cruise/" +
          _offer.br_name +
          "/" +
          _offer.webFriendlyTitle;
      } else if (_offer.input_offertype.includes("Flights")) {
        window.location =
          window.location.origin +
          "/special-offers/flights/" +
          _offer.webFriendlyTitle;
      } else {
        window.location =
          window.location.origin +
          "/special-offers/" +
          _offer.br_name +
          "/" +
          _offer.webFriendlyTitle;
      }

      // Prepare data element to create a most popular Mongo Record
      var data = {};
      data.Offer_Name = _offer.br_name;
      data.Package_Name = _offer.PACK_NAME;
      data.Website = this.siteVars.referer;
      data.Counter = 1;
      data.UNID = _offer["@unid"];

      await updateMostPopular(data);
    },
    dropdownToggleDestination() {
      this.dropdownDestination = !this.dropdownDestination;
    },
    dropdownToggleStyle() {
      this.dropdownStyle = !this.dropdownStyle;
    },
    sortFilterChanged() {
      if (this.filter.sort === "ascending") {
        this.filteredOffers.sort(function(a, b) {
          return a.price - b.price;
        });
      } else if (this.filter.sort === "descending") {
        this.filteredOffers.sort(function(a, b) {
          return b.price - a.price;
        });
      } else if (this.filter.sort === "mostPopular") {
        this.filteredOffers.sort(function(a, b) {
          return a.most_popular_order - b.most_popular_order;
        });
      }
    },
    perPageFilterChanged() {
      if (this.filter.perPage === "All")
        this.perPage = this.filteredOffers.length;
      else this.perPage = this.filter.perPage;
    },
    filterChanged() {
      this.activeFilters = [];
      Object.entries(this.filter.destinations).forEach((item) => {
        if (item[1]) this.activeFilters.push(item[0]);
      });
      Object.entries(this.filter.styles).forEach((item) => {
        if (item[1]) this.activeFilters.push(item[0]);
      });
      this.buildFilteredList();
    },
    buildFilteredList() {
      this.filteredOffers = this.offers;
      if (this.activeFilters.length > 0) {
        this.filteredOffers = [];
        let tmpArray = [...this.offers];
        // Keep filtering the results based on all the filters chosen
        this.activeFilters.some((filter) => {
          let proceed = true;
          const filteredOffers = [];
          tmpArray.some((offer) => {
            let input_continent_mod = offer.input_continent
              .toString()
              .replace(/\s/g, "-")
              .replace(/&/g, "and")
              .replace(/,/g, "-");
            let input_offertype_mod = offer.input_offertype
              .toString()
              .replace(/\s/g, "-")
              .replace(/&/g, "and")
              .replace(/,/g, "-");
            if (
              (input_continent_mod.indexOf(filter) >= 0 && proceed === true) ||
              (input_offertype_mod.indexOf(filter) >= 0 && proceed === true)
            ) {
              filteredOffers.push(offer);
            }
            tmpArray = filteredOffers;
          });
        });
        this.filteredOffers = tmpArray;
      }
      this.total_rows = this.filteredOffers.length;
      this.currentPage = 1;
    },
    removeFilter(value) {
      if (this.filter.destinations[value])
        this.filter.destinations[value] = false;
      if (this.filter.styles[value]) this.filter.styles[value] = false;
      this.filterChanged();
    },
    clearDestinationFilter() {
      this.filter.destinations = {};
      this.filterChanged();
    },
    clearStyleFilter() {
      this.filter.styles = {};
      this.filterChanged();
    },
    async getHolidayTypeCount() {
      this.offerTypes.forEach(async (item) => {
        await getOfferTypes(
          window.siteVar.referer,
          item.value
            .toLowerCase()
            .split(" ")
            .join("-")
            .replace(/&/g, "and")
        ).then((res) => {
          if (res.length > 0) {
            this.offerLinkData.push({
              type: item.value,
              data: res,
            });
          }
        });
      });
    },
    getIndividualURL(type) {
      let URL;
      if(type.value === 'Round The World')URL = '/flights/around-the-world' 
      this.offerLinkData.forEach((item) => {
        if (item.type === type.value) {
          if (item.data.length > 1) {
            //URL = `/special-offers/style/${type.href}`
            URL = `${type.href}`;
          } else {
            URL = `${item.data[0].$offerlink}`;
          }
        }
      });

      return URL;
    },
    initialSortOrder(offers) {
      const sortedOffers = [];
      const unsortedOffers = [];

      offers.forEach((item) => {
        // Group together any items that have initial_sort_homepage set
        if (item.most_popular_order) {
          sortedOffers.push(item);
        } else {
          // Gather any items that dont have initial_sort_homepage set
          unsortedOffers.push(item);
        }
      });

      // Sort sortedOffers by initial_sort_homepage
      sortedOffers.sort(
        (a, b) => a.most_popular_order - b.most_popular_order
      );

      // Sort unsortedOffers by created
      unsortedOffers.sort((a, b) =>
        new Date(a.created) < new Date(b.created) ? 1 : -1
      );
      // Merge arrays
      const combinedOffers = [...sortedOffers, ...unsortedOffers];
      // Update offers
      this.offers = combinedOffers;
      // Override initial filter
      this.filteredOffers = this.offers;
    },
    sortTileOrder(tiles) {
      const sortedTiles = [];
      const unsortedTiles = [];

      tiles.forEach((tile) => {
        if (tile.sortOrder) {
          sortedTiles.push(tile);
        } else {
          unsortedTiles.push(tile);
        }
      });

      // Sort sorted tiles
      sortedTiles.sort((a, b) => a.sortOrder - b.sortOrder);
      // merge arrays
      return [...sortedTiles, ...unsortedTiles];
    },
  },
  computed: {
    paginatedOffers: function() {
      return this.filteredOffers.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    startPageNumber: function() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    endPageNumber: function() {
      let number;
      number = this.currentPage * this.perPage;
      if (number > this.filteredOffers.length)
        number = this.filteredOffers.length;
      return number;
    },
  },
};
</script>

<style scoped lang="scss">
/*.express-vue-temp .breadcrumb{border-radius:0; padding:0 15px;}
.express-vue-temp .breadcrumb a:hover{text-decoration: none;}*/
.offer-header {
  height: 250px !important;
}
.special-offer-tile:nth-child(10) {
  display: none;
}
.box-icon:before {
  font-family: Material Icons;
  content: "\ef4f";
}
.filter-btn {
  cursor: pointer;
}

.dropdown {
  background-color: #fff;
  padding: 40px;

  h2 {
    font-size: 30px;
  }
}
.header-dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;

  span {
    cursor: pointer;
  }
}
.dropdown-boxes {
  display: grid;
  grid-template-columns: 1fr;
}

.panel-footer {
  display: flex;
  justify-content: flex-start;
}

.clear-btn {
  background-color: #434343;
  color: #fff;
  border: none;
  padding: 10px;
  cursor: pointer;
}
.form-control {
  border: none;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
}
.active-filters {
  background-color: #fff;
  padding: 30px 10px;
  margin: 20px 0;

  p {
    font-weight: bold;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
}
.active-filter-item {
  cursor: pointer;
}
.active-filter-content {
  display: inline-block;
  padding: 8px;
  font-size: 14px;
  background-color: #f1f1f1;
  color: #434343;

  span {
    margin-right: 10px;
  }

  i {
    position: relative;
    top: 2px;
  }
}
.active-filter-content:hover {
  color: #434343;
  text-decoration: none;
}
.pagination {
  display: flex;
  padding-left: 0;
  margin: 30px auto;
  border-radius: 0;
}
.express-vue-temp .page-link {
  position: relative;
  float: left;
  padding: 5px 15px;
  line-height: 1.42857;
  text-decoration: none;
  color: #434343;
  background-color: transparent;
  border: 1px solid #ddd;
  margin-right: -1px;
  margin-top: -1px;
  margin-bottom: 0;
  margin-left: 0;
}
.panel-footer {
  display: block;
}
@media only screen and (min-width: 700px) {
  .dropdown-boxes {
    grid-template-columns: repeat(2, 1fr);
  }
  .panel-footer {
    justify-content: flex-end;
  }
}
.special-offer-tile[href=""],
.special-offer-tile:not([href]) {
  display: none;
}
</style>
